import {
  cloneElement,
  FC,
  Fragment,
  isValidElement,
  ReactElement,
  ReactNode,
} from "react";

import {
  LockIcon,
} from '@repo/edtech-assets';
import clsx from "clsx";

import {
  BorderRadiusSize,
} from "../../../model";

import st from "./LessonWrapper.module.scss";

type Props = {
  children: ReactNode,
  radiusSize?: BorderRadiusSize,
  isBlocked?: boolean,
  showSuccessBlock?: boolean,
  onCloseSuccessBlock?: () => void,
};

const renderWithRadiusClass = (child: ReactNode, radiusSize: BorderRadiusSize) => {
  if (
    isValidElement(child) &&
    typeof child.type !== "string" &&
    child.type !== Fragment
  ) {
    return cloneElement(child as ReactElement<HTMLElement>, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      className: clsx(child.props.className, st[ `radius_${radiusSize}` ]),
    });
  }
  return child;
};

export const LessonWrapper: FC<Props> = ({
  children,
  radiusSize = BorderRadiusSize.M,
  isBlocked = false,
  showSuccessBlock = false,
  onCloseSuccessBlock,
}) => {
  /* [#wpr-7412] Отключить отображение экрана поздравления по курсу
     https://youtrack.wildberries.ru/issue/wpr-7412
  if (showSuccessBlock) {
    return (
      <div className={clsx(st.success_block, st[ `radius_${radiusSize}` ])}>
        <button
          aria-label="Закрыть"
          className={st.close_button}
          type="button"
          onClick={onCloseSuccessBlock}
        >
          <CrossSmallIcon />
        </button>
        <div className={st.success_content}>
          <div className={st.success_icon}>
            <VerifiedBadgeIcon />
          </div>
          <h2 className={st.success_title}>Поздравляем!</h2>
          <p className={st.success_subtitle}>
            Курс пройден! Мы надеемся, что обучение было для тебя интересным и полезным!
          </p>
        </div>
      </div>
    );
  }
  */

  return (
    <div className={clsx(st.wrap)}>
      {renderWithRadiusClass(children, radiusSize)}

      {
        isBlocked && (
          <div className={clsx(st.overlay, st[ `radius_${radiusSize}` ])}>
            <div className={st.content}>
              <LockIcon className={st.icon} />
              <h2 className={st.title}>Этот материал пока недоступен</h2>
              <p className={st.description}>
                Чтобы продолжить, пожалуйста, завершите предыдущий раздел. Это
                поможет вам лучше понять текущую тему и успешно освоить данный
                материал.
              </p>
            </div>
          </div>
        )
      }
    </div>
  );
};
